export const fetchDatabase = async (url: string, signal?: AbortSignal) => {
    const resp = await fetch(url, {
        signal,
    });
    if (resp.status < 400) {
        const data = await resp.arrayBuffer();
        return new Uint8Array(data);
    }
    throw new Error(`Db fetch error ${resp.statusText}`);
};
